import { render, staticRenderFns } from "./waterQuality.vue?vue&type=template&id=7264e6b5&scoped=true&"
import script from "./waterQuality.vue?vue&type=script&lang=js&"
export * from "./waterQuality.vue?vue&type=script&lang=js&"
import style0 from "./waterQuality.vue?vue&type=style&index=0&id=7264e6b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264e6b5",
  null
  
)

export default component.exports